const app = {};

app.trustedShops = {
    nl: 'X6BAFDC1FE09DC558CBCAC537F2644C19',
    de: 'XA6F9FAD7F92608F1F7AAC3FCB8E35B47',
    en: 'X9A23CE7864D34D2960170B99E6411645',
    fr: 'X1D30A832666176E4321E375E542F3465'
}

app.getEncodedSkus = skus => {
    const cleanSkus = unescape(encodeURIComponent(skus));
    let encodedSkus = '';

    for(let i = 0; i< cleanSkus.length; i++) {
        encodedSkus += cleanSkus.charCodeAt(i).toString(16);
    }

    return encodedSkus;
}

app.parsePrice = price => parseInt((price).replace(/[.,]/g, ''));

app.currency = (price, symbol = true) => {
    if (!symbol) {
        price = ((+(price.toString().replace('.', ''))) / 100).toLocaleString(`${window.Shopify.locale}-${window.Shopify.country}`, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    } else {
        price = ((+(price.toString().replace('.', ''))) / 100).toLocaleString(`${window.Shopify.locale}-${window.Shopify.country}`, {
            style: 'currency',
            currency: 'eur',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    price = price.replace(/\u00a0/g, '');

    return price;
};

app.getDayDifference = (a, b) => parseInt(((a.getTime() - b.getTime()) / (1000 * 3600 * 24)).toString().replace('-', ''));

app.getNextDeliveryDate = (date = null, hour = null) => {
    const monthTranslations = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const orderBeforeHour = parseInt(document.body.getAttribute('data-order-before-hour'));
    const skippedDates = document.body.getAttribute('data-deliverydate-skipped') === '' ? null : document.body.getAttribute('data-deliverydate-skipped');

    let isSkippedDate = false;
    const currentDay = new Date();
    currentDay.setHours(0,0,0,0);

    if(date === null) {
        date = new Date();
    }

    if(hour === null) {
        hour = date.getHours();
    }

    date.setHours(0,0,0,0);
    date.setDate(date.getDate() + 1);

    if(app.getDayDifference(currentDay, date) === 1 && hour >= orderBeforeHour) {
        date.setDate(date.getDate() + 1);
    }

    if(skippedDates !== null) {
        skippedDates.split(',').map(skippedDate => {
            skippedDate = new Date(skippedDate);

            if(skippedDate.getTime() === date.getTime()) {
                isSkippedDate = true;
            }
        });
    }

    if(!isSkippedDate && date.getDay() === 0) {
        isSkippedDate = true;
    }

    if(isSkippedDate) {
        date = app.getNextDeliveryDate(date, hour);
    } else {
        const difference = app.getDayDifference(currentDay, date);

        let deliveryDate = document.body.getAttribute('data-translate-tomorrow');

        if(difference === 2) {
            deliveryDate = document.body.getAttribute('data-translate-day-after-tomorrow');
        } else if(difference > 2) {
            console.log(date.getMonth());
            deliveryDate = date.getDate() +' '+ document.body.getAttribute('data-translate-' + date.getMonth());
            //deliveryDate = date.getDate() +' '+ app.t(monthTranslations[date.getMonth()]);
        }

        if(hour >= orderBeforeHour) {
            return document.body.getAttribute('data-translate-ordertoday');
        }

        return document.body.getAttribute('data-translate-orderbefore');
    }

    return date;
};

app.image = (url, w = null, h = null) => `${url}${w ? `&width=${w}` : ''}${h ? `&height=${h}` : ''}`;

app.lockBody = (keepScrollbar = true) => {
    const scrollTop = window.scrollY;

    document.body.classList.add('locked');

    if(scrollTop === 0) {
        document.body.classList.add('locked--on-top');
    }

    if(keepScrollbar && document.documentElement.scrollHeight > document.documentElement.clientHeight) {
        document.body.style.overflowY = 'scroll';
    }

    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.setProperty('margin-top', `-${scrollTop}px`, 'important');

    document.body.dataset.scrollTop = scrollTop;
};

app.unlockBody = () => {
    document.body.classList.remove('locked', 'locked--on-top');

    document.body.style.removeProperty('position');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('overflow-y');
    document.body.style.removeProperty('margin-top');

    window.scrollTo({top: document.body.dataset.scrollTop});
    document.body.removeAttribute('data-scroll-top');
};

app.viewport = {
    sizes: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
    is: () => window.getComputedStyle(document.body, ':after').content.replace(/"/g, ''),
    isEqualOrGreaterThan: size => app.viewport.getIndex(app.viewport.is()) >= app.viewport.getIndex(size),
    isEqualOrSmallerThan: size => app.viewport.getIndex(app.viewport.is()) <= app.viewport.getIndex(size),
    isSmallerThan: size => app.viewport.getIndex(app.viewport.is()) < app.viewport.getIndex(size),
    getIndex: size => {
        const number = app.viewport.sizes.indexOf(size);
        if (number === -1) throw 'no valid viewport name given';
        return number;
    }
};

export default app;
